import { HttpClient, isApiError } from '@/shared';
import AmendmentStatus from '../../application/domain/entities/AmendmentStatus';
import { IAmendmentRepository } from '../../application/ports/outbound/IAmendmentRepository';
import AmendmentStatusResponseDto from './dto/res/AmendmentStatusResponseDto';
import { mapAmendmentStatusDtoToEntity } from './mappers/amendmentStatusMapper';

/**
 * API Amendment Repository Implementation
 * Handles HTTP calls to fetch amendment status
 */
export class ApiAmendmentRepository implements IAmendmentRepository {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Fetch amendment status from API
   * GET /core/api/i9Form/{i9FormId}/amendment-status
   *
   * Response wrapper format:
   * {
   *   statusCode: 200,
   *   message: "Success",
   *   data: { isAmendmetnInProgress: boolean, amendmentReason: string }
   * }
   */
  async fetchAmendmentStatus(i9FormId: string): Promise<AmendmentStatus | null> {
    try {
      const response = await this.httpClient.get<AmendmentStatusResponseDto>(
        `/i9Form/${i9FormId}/amendment-status`
      );
      return response.data ? mapAmendmentStatusDtoToEntity(response.data) : null;
    } catch (error) {
      // HttpClient has already reported a failed request; logging it again filed it twice (VTK-1860).
      if (!isApiError(error)) console.error('Failed to fetch amendment status:', error);
      return null; // Return null on error to allow graceful degradation
    }
  }
}

export default ApiAmendmentRepository;
